import React, { useRef, useState } from 'react';
import { Modal, Input, message } from 'antd';
import { Editor } from '@toast-ui/react-editor';
import { useAppDispatch } from '../../../Modules/Presentation/hooks';
import { addNotice } from '../../../Modules/Notice/Presentation/actions';
import { CreateNoticeDTO } from '../../../Modules/Notice/Domain/Repositories/NoticeRepository';

import '@toast-ui/editor/dist/toastui-editor.css';

interface Props { open: boolean; onClose: () => void }

const toolbar = [
  ['bold', 'italic', 'strike'],
  ['ul', 'ol', 'hr'],
  ['quote', 'table'],
];

const NoticeWriteModal: React.FC<Props> = ({ open, onClose }) => {
  const dispatch = useAppDispatch();
  const editorRef = useRef<Editor>(null);
  const [title, setTitle] = useState('');

  const reset = () => {
    setTitle('');
    editorRef.current?.getInstance().setMarkdown('');
    onClose();
  };

  const handleSubmit = async () => {
    const md = editorRef.current?.getInstance().getMarkdown() ?? '';
    if (!title.trim()) { message.warning('제목을 입력하세요'); return; }
    if (!md.trim()) { message.warning('내용을 입력하세요'); return; }

    const dto: CreateNoticeDTO = { title, content: md, authorId: 1 };

    try {
      await dispatch(addNotice(dto)).unwrap();
      message.success('등록이 완료되었습니다.');
      reset();
    } catch { message.error('등록에 실패하였습니다.'); }
  };

  return (
    <Modal
      open={open}
      title="공지 작성"
      onOk={handleSubmit}
      onCancel={reset}
      okText="등록"
      width={860}
      destroyOnClose
    >
      <label>제목</label>
      <Input
        value={title}
        onChange={e => setTitle(e.target.value)}
        placeholder="제목을 입력하세요"
        style={{ marginBottom: 16 }}
      />

      <label>내용</label>
      <Editor
        ref={editorRef}
        initialEditType="wysiwyg"
        hideModeSwitch
        toolbarItems={toolbar}
        height="420px"
        usageStatistics={false}
        hooks={{ addImageBlobHook: () => false }}
      />
    </Modal>
  );
};

export default NoticeWriteModal;
